import { jsx as o, jsxs as m } from "react/jsx-runtime";
import { components as c } from "react-select";
import { noOptionsMessageStyles as p, groupHeadingStyles as h, menuStyles as S, indicatorsContainerStyles as b, valueContainerStyles as y, placeholderStyles as g, optionStyles as l, dropdownIndicatorStyles as r, singleValueStyles as a, selectInputStyles as d, controlStyles as i } from "./styles.js";
import { Icon as f } from "@tameeni/icons";
import { cn as s } from "@tameeni/shared-logic";
const O = (e) => {
  const { children: t, isSelected: n } = e;
  return /* @__PURE__ */ o(c.Option, { ...e, isMulti: !0, children: /* @__PURE__ */ m("div", { className: "flex items-center", children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: s(
          "w-4 h-4 border flex items-center justify-center me-2 rounded-xs",
          n ? "border-green-500 bg-green-500" : "border-slate-400 bg-white"
        ),
        children: n && /* @__PURE__ */ o(f, { className: "w-3 h-3 text-white", name: "Checked" })
      }
    ),
    t
  ] }) });
}, N = (e) => {
  const { hasValue: t, isFocused: n, selectProps: u } = e;
  return /* @__PURE__ */ o(
    c.Input,
    {
      ...e,
      isHidden: !1,
      className: s(
        t && !n && "text-slate-500 text-b2 capitalize truncate"
      ),
      placeholder: t && !n && u.placeholder
    }
  );
}, M = (e) => ({
  control: ({
    isDisabled: t,
    isMulti: n
  }) => s(
    i.base,
    t && i.disabled,
    n && i.multi,
    e.isInvalid && i.invalid,
    e.isMenuOpened && i.menuOpened
  ),
  placeholder: () => g,
  multiValue: () => "!hidden",
  input: () => s(d.base, e.isSelected && d.selected),
  valueContainer: () => y,
  singleValue: () => s(a.base, e.isSelected && a.selected),
  indicatorsContainer: () => b,
  indicatorSeparator: () => "none",
  dropdownIndicator: ({ isDisabled: t }) => s(
    r.base,
    t && r.disabled
  ),
  menu: () => S,
  groupHeading: () => h,
  option: ({ isSelected: t }) => s(t && l.selected, l.base),
  noOptionsMessage: () => p,
  clearIndicator: () => "!hidden"
});
export {
  N as CustomInput,
  O as CustomOption,
  M as getClassNames
};
